import styled from 'styled-components';
import Button from '../button/Button';
export const UsdtImg = styled.img `
  height: 16.8rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -7rem;

  ${({ theme }) => theme.media.laptop `
      height: 32rem;
  `}
`;
export const TextAndButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 2.2rem;
  ${({ theme }) => theme.media.laptop `
      gap: 1.2rem;
  `}
`;
export const CustomButton = styled(Button) `
  height: 6rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin-top: 2.2rem;
  ${({ theme }) => theme.media.laptop `
    margin-top: 1.6rem;
  `}
`;
export const ContentWrapper = styled.div `
  ${({ theme }) => theme.media.laptop `
        display: flex;
        flex-direction: column;
        justify-content: center;

        margin: 2rem 0;
    `}
`;
//# sourceMappingURL=styles.js.map